import api from "api/axios";

export const patientHistoryMasterApi = (master) => {
  const base = `/admin/patient-history/${master}`;

  return {
    list: (params) => api.get(base, { params }),
    get: (id) => api.get(`${base}/${id}`),
    create: (payload) => api.post(base, payload),
    update: (id, payload) => api.put(`${base}/${id}`, payload),
    remove: (id) => api.delete(`${base}/${id}`),
    importFile: (file) => {
      const body = new FormData();
      body.append("file", file);
      return api.post(`${base}/import`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    download: (kind, params) =>
      api.get(`${base}/${kind}`, { params, responseType: "blob" }),
  };
};

/** The Specialization master, as the Complaint Master's modal reads it. */
export const listSpecialities = () =>
  api.get("/specialization").then((res) => {
    const list = res?.data?.data?.Specialization;
    return Array.isArray(list) ? list : [];
  });
